import { initializeFieldInterface } from './fields/initializeFieldInterface';
import { initializeFilterInterface } from './filters/initializeFilterInterface';
import { initializeReferenceInterface } from './references/initializeReferenceInterface';
import { initializeComponentInterface } from './components/initializeComponentInterface';
import { initializeTagInterface } from './tags/initializeTagInterface';
import { initializeWorkspaceInterface } from './workspaces/initializeWorkspaceInterface';
import { initializeFeatureInterface } from './features/initializeFeatureInterface';
import { initializePrivilegesInterface } from 'admin/privileges';
import { initializeDataInterface } from 'dataInterface/initializeDataInterface';

export const initializeModelInterfaces = () => {
  initializeFilterInterface();
  initializeComponentInterface();
  initializeReferenceInterface();
  initializeFieldInterface();
  initializeTagInterface();
  initializeWorkspaceInterface();
  initializeFeatureInterface();
  initializePrivilegesInterface();
  initializeDataInterface();
};
